// 充值来源
export const DEPOSIT_TYPE_MAP = {
  'rummy': 'rummy_deposit',
  'casual': 'casual_deposit',
};

// 币种对应的入口
export const CURRENCY_MAP_ENTRANCE = {
  'USDT': 'deposit-crypto',
  'INR': 'deposit-cash',
};